module.exports = __webpack_public_path__ + "static/media/user-down-arrow.1e0e23fe.svg";